import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('frontend-preferences-client');